module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card column no-shadow"
  }, [_c('div', {
    staticClass: "card-title text-primary"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.logo
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.info.name))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.info.website,
      "target": "_blank"
    }
  }, [_vm._v("website")])]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', [_c('div', [_vm._v(_vm._s(_vm.schoolSummary.schoolType))]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("Mother Tongue Offered:")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.schoolSummary.motherTongue))]), _vm._v(" "), (_vm.schoolSummary.higherMT) ? [_c('dt', [_vm._v("Higher Mother Tongue Offered:")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.schoolSummary.higherMT))])] : _vm._e(), _vm._v(" "), (_vm.schoolSummary.moeProgrammes) ? [_c('dt', [_vm._v("Special Programmes:")]), _vm._v(" "), _vm._l((_vm.schoolSummary.moeProgrammes), function(row) {
    return _c('dd', [(row.href) ? _c('a', {
      attrs: {
        "href": row.href,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(row.value))]) : _c('span', [_vm._v(_vm._s(row.value))])])
  })] : _vm._e(), _vm._v(" "), (_vm.p1Registration) ? [_c('dt', [_vm._v("\n            " + _vm._s(_vm.p1Registration.year) + " " + _vm._s(_vm.p1Registration.label) + ":\n            "), _vm._v("\n             "), _vm._m(0)]), _vm._v(" "), _c('dd', [_c('table', {
    staticClass: "p1-registration"
  }, [_vm._l((_vm.p1Registration.rows), function(row) {
    return [(row.values) ? _vm._l((row.values), function(r) {
      return (r.value) ? _c('tr', [_c('td', {
        staticStyle: {
          "padding-left": "10px"
        }
      }, [_c('em', [_vm._v(_vm._s(r.label))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(r.value))])]) : _vm._e()
    }) : (row.value) ? _c('tr', {
      class: row.class
    }, [_c('td', [_vm._v(_vm._s(row.label))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.value))]), _vm._v(" "), (row.title) ? _c('q-tooltip', {
      attrs: {
        "anchor": "bottom left",
        "self": "top left",
        "offset": [10, 5]
      }
    }, [_c('div', [_vm._v(_vm._s(row.title))])]) : _vm._e()], 1) : _vm._e()]
  })], 2)])] : _vm._e(), _vm._v(" "), (_vm.cutOffPoints) ? [_c('dt', [_vm._v(_vm._s(_vm.cutOffPoints.year) + " " + _vm._s(_vm.cutOffPoints.label) + ":")]), _vm._v(" "), _c('dd', [_c('table', {
    staticClass: "cop-details"
  }, _vm._l((_vm.cutOffPoints.rows), function(prog) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(prog.programme))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(prog.lower) + " - " + _vm._s(prog.upper))])])
  }))])] : _vm._e(), _vm._v(" "), (_vm.l1r5History) ? [_c('dt', [_vm._v(_vm._s(_vm.l1r5History.year) + " " + _vm._s(_vm.l1r5History.label) + ":")]), _vm._v(" "), _c('dd', [_c('table', {
    staticClass: "l1r5-details"
  }, _vm._l((_vm.l1r5History.rows), function(prog) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(prog.programme) + ": ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(prog.lower) + " - " + _vm._s(prog.upper))])])
  }))])] : _vm._e()], 2)]), _vm._v(" "), _c('span', {
    staticClass: "action-bookmark cursor-pointer text-primary",
    class: {
      'text-bookmark': _vm.bookmarked
    },
    on: {
      "click": function($event) {
        _vm.$emit('bookmark', _vm.info.id)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.bookmarked ? '/assets/Star_Green.svg' : '/assets/Star_Blue.svg'
    }
  }), _vm._v("\n      Bookmark\n    ")]), _vm._v(" "), (_vm.travelTime) ? _c('span', {
    staticClass: "action-traveltime"
  }, [_c('img', {
    attrs: {
      "src": "/assets/Car.svg"
    }
  }), _vm._v("\n      " + _vm._s(_vm.travelTime) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "list item-delimiter auto column text-primary"
  }, [_c('q-collapsible', {
    ref: "ccaAchievements",
    attrs: {
      "label": "CCA ACHIEVEMENTS",
      "opened": true
    }
  }, [_c('div', [(_vm.syfAchievements && _vm.syfAchievements.rows.length > 0) ? _c('div', {
    staticClass: "achivement-container"
  }, [_c('dt', [_vm._v(_vm._s(_vm.syfAchievements.label))]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('td'), _vm._v(" "), _vm._l((_vm.syfAchievements.awardYears), function(year) {
    return _c('td', {
      staticClass: "year-label"
    }, [_vm._v(_vm._s(year))])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.syfAchievements.rows), function(row) {
    return (_vm.syfAchievements.awardYears.some(function (year) { return _vm.medalIcon[row.awards[year]]; })) ? _c('tr', {
      staticClass: "achievement-row"
    }, [_c('td', {
      staticClass: "cca-label text-bold"
    }, [_vm._v(_vm._s(row.category))]), _vm._v(" "), _vm._l((_vm.syfAchievements.awardYears), function(year) {
      return _c('td', [(_vm.medalIcon[row.awards[year]]) ? _c('img', {
        attrs: {
          "src": _vm.medalIcon[row.awards[year]]
        }
      }) : _vm._e()])
    })], 2) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('div', [_vm._v("LEGEND")]), _vm._v(" "), _vm._l((_vm.syfAchievements.legendItems), function(item) {
    return _c('div', {
      staticClass: "text-primary"
    }, [_c('img', {
      attrs: {
        "src": _vm.medalIcon[item]
      }
    }), _vm._v(_vm._s(item) + "\n            ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.buaAchievements && _vm.buaAchievements.rows.length > 0) ? _c('div', {
    staticClass: "achivement-container"
  }, [_c('dt', [_vm._v(_vm._s(_vm.buaAchievements.label))]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('td'), _vm._v(" "), _vm._l((_vm.buaAchievements.awardYears), function(year) {
    return _c('td', {
      staticClass: "year-label"
    }, [_vm._v(_vm._s(year))])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.buaAchievements.rows), function(row) {
    return (_vm.buaAchievements.awardYears.some(function (year) { return _vm.medalIcon[row.awards[year]]; })) ? _c('tr', {
      staticClass: "achievement-row"
    }, [_c('td', {
      staticClass: "cca-label text-bold"
    }, [_vm._v(_vm._s(row.category))]), _vm._v(" "), _vm._l((_vm.buaAchievements.awardYears), function(year) {
      return _c('td', [(_vm.medalIcon[row.awards[year]]) ? _c('img', {
        attrs: {
          "src": _vm.medalIcon[row.awards[year]]
        }
      }) : _vm._e()])
    })], 2) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('div', [_vm._v("LEGEND")]), _vm._v(" "), _vm._l((_vm.buaAchievements.legendItems), function(item) {
    return _c('div', {
      staticClass: "text-primary"
    }, [_c('img', {
      attrs: {
        "src": _vm.medalIcon[item]
      }
    }), _vm._v(_vm._s(item) + "\n            ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.sportAchievements && _vm.sportAchievements.rows.length > 0) ? _c('div', {
    staticClass: "achivement-container"
  }, [_c('dt', [_vm._v(_vm._s(_vm.sportAchievements.label))]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('td'), _vm._v(" "), _vm._l((_vm.sportAchievements.awardYears), function(year) {
    return _c('td', {
      staticClass: "year-label"
    }, [_vm._v(_vm._s(year))])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.sportAchievements.rows), function(row) {
    return (_vm.sportAchievements.awardYears.some(function (year) { return _vm.medalIcon[row.awards[year]]; })) ? _c('tr', {
      staticClass: "achievement-row"
    }, [_c('td', {
      staticClass: "cca-label text-bold"
    }, [_c('div', [_vm._v(_vm._s(row.category))]), _c('small', {
      staticClass: "text-italic"
    }, [_vm._v(_vm._s(row.subCategory))])]), _vm._v(" "), _vm._l((_vm.sportAchievements.awardYears), function(year) {
      return _c('td', [(_vm.medalIcon[row.awards[year]]) ? _c('img', {
        attrs: {
          "src": _vm.medalIcon[row.awards[year]]
        }
      }) : _vm._e()])
    })], 2) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('div', [_vm._v("LEGEND")]), _vm._v(" "), _vm._l((_vm.sportAchievements.legendItems), function(item) {
    return _c('div', {
      staticClass: "text-primary"
    }, [_c('img', {
      attrs: {
        "src": _vm.medalIcon[item]
      }
    }), _vm._v(_vm._s(item) + "\n            ")])
  })], 2)]) : _vm._e()])]), _vm._v(" "), (_vm.distinctiveProgrammes) ? _c('q-collapsible', {
    ref: "distinctiveProgrammes",
    attrs: {
      "label": "DISTINCTIVE PROGRAMMES"
    }
  }, [_vm._l((_vm.distinctiveProgrammes), function(row) {
    return [_c('dt', [_vm._v(_vm._s(row.label))]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(row.value))])]
  })], 2) : _vm._e(), _vm._v(" "), _c('q-collapsible', {
    ref: "generalInfo",
    attrs: {
      "label": "GENERAL INFO"
    }
  }, [_c('dl', [_vm._l((_vm.generalInfo), function(row) {
    return (row.value) ? [_c('dt', [_vm._v(_vm._s(row.label))]), _vm._v(" "), (Array.isArray(row.value)) ? _vm._l((row.value), function(value) {
      return _c('dd', [_vm._v(_vm._s(value))])
    }) : _c('dd', [_vm._v(_vm._s(row.value))])] : _vm._e()
  })], 2)]), _vm._v(" "), _c('q-collapsible', {
    ref: "subjectsOffered",
    attrs: {
      "label": "SUBJECTS"
    }
  }, [_c('div', {
    staticStyle: {
      "column-count": "2"
    }
  }, _vm._l((_vm.subjectsOffered), function(subject) {
    return _c('div', [_vm._v(_vm._s(subject))])
  }))]), _vm._v(" "), _c('q-collapsible', {
    ref: "ccasOffered",
    attrs: {
      "label": "CCAs"
    }
  }, [_c('div', {
    staticClass: "row wrap"
  }, _vm._l((_vm.ccasOffered), function(row) {
    return _c('dl', {
      staticClass: "width-1of2"
    }, [_c('dt', [_vm._v(_vm._s(row.label))]), _vm._v(" "), _vm._l((row.values), function(value) {
      return _c('dd', [_vm._v("\n            " + _vm._s(value) + "\n          ")])
    })], 2)
  }))]), _vm._v(" "), _c('q-collapsible', {
    ref: "contactInfo",
    staticClass: "text-primary",
    attrs: {
      "label": "CONTACT"
    }
  }, [_c('dl', [_vm._l((_vm.contactInfo), function(row) {
    return (row.value) ? [_c('dt', [_vm._v(_vm._s(row.label))]), _vm._v(" "), (row.href) ? [_c('dd', [_c('a', {
      attrs: {
        "href": row.href,
        "target": row.href.match(/^mailto/) ? null : '_blank'
      }
    }, [_vm._v("\n              " + _vm._s(row.value) + "\n            ")])])] : _c('dd', [_vm._v(_vm._s(row.value))])] : _vm._e()
  })], 2)]), _vm._v(" "), _c('q-collapsible', {
    ref: "gettingThere",
    attrs: {
      "label": "GETTING THERE"
    }
  }, [_c('dl', [_vm._l((_vm.gettingThere), function(row) {
    return (row.value) ? [_c('dt', [_vm._v(_vm._s(row.label))]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(row.value))])] : _vm._e()
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "exit absolute-top-right cursor-pointer",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "text-grey"
  }, [_vm._v("\n      clear\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://beta.moe.gov.sg/primary/p1-registration/vacancies-and-balloting/"
    }
  }, [_c('small', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("(application closed)")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-020cc8c2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-020cc8c2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DetailView/DetailCard.vue
// module id = 839
// module chunks = 0